<!-- Barra: buscador, filtros y contador -->
<div class="od-toolbar">
  <label class="od-input" style="width: 248px; max-width: 100%">
    <od-icon name="search"></od-icon>
    <input type="search" [formControl]="buscar" placeholder="Nombre o cédula" aria-label="Buscar por nombre o cédula" autocomplete="off">
  </label>
  <label class="od-select">
    <span>Estado:</span>
    <select aria-label="Filtrar por estado" (change)="elegirEstado($any($event.target).value)">
      <option *ngFor="let e of estados; trackBy: porValor" [value]="e.valor" [selected]="filtro.estado === e.valor">{{ e.texto }}</option>
    </select>
  </label>
  <label class="od-select">
    <span>Comercio:</span>
    <select aria-label="Filtrar por comercio" (change)="elegirComercio($any($event.target).value)">
      <option value="" [selected]="!filtro.comercio">Todos</option>
      <option *ngFor="let c of comercios$ | async; trackBy: porCode" [value]="c.code" [selected]="filtro.comercio === c.code">{{ c.nombre }}</option>
    </select>
  </label>
  <span class="od-fin" aria-live="polite" *ngIf="lista$ | async as v">
    <ng-container *ngIf="v.datos">{{ numero(v.datos.total) }} {{ v.datos.total === 1 ? 'cliente' : 'clientes' }}</ng-container>
  </span>
</div>

<ng-container *ngIf="lista$ | async as v">
  <!-- Error -->
  <div class="od-alert" role="alert" *ngIf="v.error">
    <od-icon name="alert" [size]="16"></od-icon>
    <div class="od-alert-tx"><b>No se pudo traer la lista de clientes</b><div class="od-muted">{{ v.error }}</div></div>
    <button type="button" class="od-btn" (click)="recargar()"><od-icon name="refresh"></od-icon>Reintentar</button>
  </div>

  <!-- Cargando por primera vez -->
  <div *ngIf="v.cargando && !v.datos" aria-busy="true" aria-label="Cargando clientes">
    <div class="od-skeleton" style="height: 38px; margin-bottom: 6px"></div>
    <div class="od-skeleton" style="height: 40px; margin-bottom: 6px" *ngFor="let i of esperaSkeleton; trackBy: porIndice"></div>
  </div>

  <ng-container *ngIf="v.datos as pag">
    <!-- Sin resultados -->
    <div class="od-empty od-card" *ngIf="!pag.items.length">
      <od-icon name="users" [size]="22"></od-icon>
      <b>{{ filtro.q || filtro.estado || filtro.comercio ? 'Ningún cliente coincide' : 'Todavía no hay clientes anotados' }}</b>
      <span>{{ filtro.q || filtro.estado || filtro.comercio ? 'Cambia la búsqueda o los filtros.' : 'Aparecen aquí cuando CrediTotal aprueba a una persona.' }}</span>
    </div>

    <div class="od-table-wrap" *ngIf="pag.items.length" [style.opacity]="v.cargando ? .6 : 1">
      <table class="od-table">
        <caption style="position: absolute; width: 1px; height: 1px; overflow: hidden; clip: rect(0 0 0 0)">Clientes que se anotan en Odoo. Toca una fila para ver su detalle.</caption>
        <thead>
          <tr>
            <th scope="col">Cliente</th><th scope="col">Cédula</th><th scope="col">Comercio</th>
            <th scope="col">Estado en Odoo</th><th scope="col">Último envío</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let f of pag.items; trackBy: trackFila" class="od-row-click" tabindex="0"
              [class.od-row-sel]="seleccionado?.source_id === f.source_id"
              [attr.aria-current]="seleccionado?.source_id === f.source_id ? 'true' : null"
              (click)="elegir(f)" (keydown.enter)="elegir(f)" (keydown.space)="elegir(f); $event.preventDefault()">
            <td>{{ f.nombre || '—' }}</td>
            <td class="od-mono">{{ f.identificacion || '—' }}</td>
            <td>{{ f.comercio_nombre || '—' }}</td>
            <td>
              <span class="od-badge od-badge-solid" *ngIf="f.estado_ui === 'anotado'"><od-icon name="check"></od-icon>Anotado</span>
              <span class="od-badge" *ngIf="f.estado_ui === 'esperando'"><od-icon name="clock"></od-icon>Esperando envío</span>
              <span class="od-badge od-badge-problem" *ngIf="f.estado_ui === 'problema'"><od-icon name="alert"></od-icon>Con problema</span>
            </td>
            <td>
              <ng-container [ngSwitch]="f.estado_ui">
                <span *ngSwitchCase="'esperando'">Se reintenta {{ f.proximo_reintento | odooHoraSola }}</span>
                <span *ngSwitchCase="'problema'">{{ f.motivo }}</span>
                <span *ngSwitchDefault>{{ f.fe_ultimo_envio | odooFechaCorta }}</span>
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Paginación -->
    <div class="od-toolbar" style="margin-top: 10px" *ngIf="pag.total > pag.limit">
      <span class="od-muted">{{ numero(desde(pag)) }}–{{ numero(hasta(pag)) }} de {{ numero(pag.total) }}</span>
      <span class="od-fin" style="display: inline-flex; gap: 6px">
        <button type="button" class="od-btn od-btn-sm" [disabled]="pag.page <= 1" (click)="pagina(pag.page - 1)">Anterior</button>
        <button type="button" class="od-btn od-btn-sm" [disabled]="pag.page >= totalPaginas(pag.total)" (click)="pagina(pag.page + 1)">Siguiente</button>
      </span>
    </div>
  </ng-container>
</ng-container>

<!-- Detalle del cliente elegido -->
<section class="od-sec" style="margin-top: 12px; border-color: var(--od-fg); border-width: 1.5px" *ngIf="seleccionado as c" aria-label="Detalle del cliente">
  <div style="display: flex; align-items: center; gap: 8px; margin-bottom: 8px">
    <h5 style="margin: 0; flex: 1; display: flex; align-items: center; gap: 6px">
      <od-icon name="user" [size]="16"></od-icon>{{ c.nombre || 'Cliente' }} · {{ c.identificacion || c.source_id }}
    </h5>
    <a class="od-btn" [routerLink]="['/console/cliente', c.source_id]">Abrir ficha</a>
  </div>
  <div class="od-kpis" style="grid-template-columns: repeat(3, minmax(0, 1fr)); margin: 4px 0 10px">
    <div class="od-kpi"><span class="od-muted">Código en Odoo</span><b>{{ c.odoo_id ?? '—' }}</b></div>
    <div class="od-kpi"><span class="od-muted">Anotado el</span><b>{{ c.fe_alta | odooDiaLargo }}</b><span class="od-muted">{{ c.fe_alta | odooHoraSola }}</span></div>
    <div class="od-kpi"><span class="od-muted">Último envío</span><b>{{ c.fe_ultimo_envio | odooDiaLargo }}</b><span class="od-muted">{{ c.fe_ultimo_envio | odooHoraSola }}</span></div>
  </div>
  <p class="od-muted" style="font-size: 11px; letter-spacing: .06em; text-transform: uppercase; font-weight: 600; margin-bottom: 2px">Últimos movimientos</p>
  <ng-container *ngIf="movimientos$ | async as m">
    <div *ngIf="m.cargando && !m.datos" aria-busy="true"><div class="od-skeleton" style="height: 32px; margin-top: 6px" *ngFor="let i of esperaMov; trackBy: porIndice"></div></div>
    <div class="od-alert od-alert-flat" role="alert" *ngIf="m.error"><od-icon name="alert" [size]="16"></od-icon><div class="od-alert-tx">{{ m.error }}</div></div>
    <p class="od-muted" style="padding: 8px 0" *ngIf="m.datos && !m.datos.length">Todavía no hay movimientos de este cliente.</p>
    <div class="od-ev" *ngFor="let e of m.datos; trackBy: trackMov">
      <span class="od-ev-tx">{{ e | odooFrase }}<span class="od-muted" *ngIf="!e.ok && e.error"> · {{ e.error }}</span></span>
      <span class="od-ev-tm">{{ e.createdAt | odooFechaCorta }}</span>
      <span class="od-badge od-badge-solid" *ngIf="e.ok"><od-icon name="check"></od-icon>Bien</span>
      <span class="od-badge od-badge-problem" *ngIf="!e.ok"><od-icon name="alert"></od-icon>Con problema</span>
    </div>
  </ng-container>
</section>
